import React, { memo, useState } from 'react'
import { Tabs, Tab } from 'transfix-ui/components/DeprecatedTabs'
import { ConfirmationModal } from 'transfix-ui/components/Modals'
import { Api } from './Api'
import { FeatureFlags } from './FeatureFlags'
import LocalLogin from './LocalLogin'

interface ISystemModalProps {
  open: boolean
  close: (action?: string) => any
}

export const SystemModal = memo<ISystemModalProps>(({ close, open }) => {
  const [currentTab, setCurrentTab] = useState('Feature Flags')

  const switchTabHandler = (tab: string) => {
    setCurrentTab(tab)
  }

  return (
    <ConfirmationModal
      title='System Info'
      onClose={close}
      open={open}
      actions={[
        {
          label: 'Ok',
          type: 'confirm',
        },
      ]}>
      <Tabs value={currentTab} onChange={switchTabHandler}>
        <Tab key='Flags' label='Feature Flags'>
          <FeatureFlags />
        </Tab>
        <Tab key='Api' label='API endpoints'>
          <Api />
        </Tab>
        {__ENV__ !== 'production' && (
          <Tab key='Local' label='Local Login'>
            <LocalLogin />
          </Tab>
        )}
      </Tabs>
    </ConfirmationModal>
  )
})
